<script setup lang="ts">
import { ref, watch } from 'vue';
import { SelectionMobileView } from '@enums/selectionMobileView.ts';
import { SelectionRoute } from '@enums/selectionRoute.ts';
import { useRouter } from 'vue-router';
import { ViewType } from './map-constants';
import MobileViewDropdown from './MobileViewDropdown.vue';

const { currentView } = defineProps<{ currentView: ViewType }>();
const router = useRouter();

const emit = defineEmits<{(event: 'set-view', view: ViewType): void }>();

const value = ref<SelectionMobileView>(currentView === ViewType.MAP ? SelectionMobileView.MAP : SelectionMobileView.LIST);

watch(() => currentView, (newView) => {
  value.value = newView === ViewType.MAP ? SelectionMobileView.MAP : SelectionMobileView.LIST;
});

const onChange = (val: SelectionMobileView):void => {
  if (val === SelectionMobileView.MAP) {
    emit('set-view', ViewType.MAP);
    router.push({ name: SelectionRoute.LIST });
    return;
  }

  if (val === SelectionMobileView.LIST) {
    emit('set-view', ViewType.LIST);
    router.push({ name: SelectionRoute.LIST });
    return;
  }

  if (val === SelectionMobileView.COMPARATOR) {
    router.push({ name: SelectionRoute.COMPARATOR });
    return;
  }

  if (val === SelectionMobileView.DASHBOARD) {
    router.push({ name: SelectionRoute.DASHBOARD });
  }
};
</script>

<template>
  <div class="sticky-tabs">
    <MobileViewDropdown :view="value" @change="onChange" />
  </div>
</template>
